

module.exports = __webpack_require__.stylable.create(
    "ColorPickerItem1923060891",
    {"classes":{"root":"ColorPickerItem1923060891__root","radioOuter":"ColorPickerItem1923060891__radioOuter","focused":"ColorPickerItem1923060891__focused","radioInner":"ColorPickerItem1923060891__radioInner"},"vars":{},"stVars":{"DefaultItemSize":"24","DefaultBorderRadius":"12","DefaultFocusColor":"color-5","Size":"--overridable","Radius":"--overridable","colorPickerItemSize":"\"unit(fallback(--overridable, 24), px)\"","colorPickerBorderRadius":"\"fallback(zeroAsTrue(--overridable), unit(12, px))\"","focusColor":"\"opacity(color(color-5), 0.6)\""},"keyframes":{}},
    "",
    8,
    "ColorPickerItem1923060891",
    null
);
